define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const Class = require('Class');

    const FIRST_LEVEL = {
        containerSel: '.menu__nav',
        elementSel: '.menu__nav-item',
        linkSel: '.menu__nav-link'
    };
    const SECOND_LEVEL = {
        containerSel: '.menu__secondlevel',
        elementSel: '.menu__secondlevel-item',
        linkSel: '.menu__secondlevel-link'
    };
    const ANIMATION_CLASS = 'animation-injected';
    const EFFECT_CLASS = 'effect';

    const getSel = function(cls) {
        return '.' + cls;
    };

    const SlideLineAnimation = Class.create({

        initialize: function(level, $el) {
            this.$el = $el;
            this.level = level;
            this.clearAnimation();
            this.$menuContainer = this.$el.find(this.level.containerSel + ':not(.hidden)');
            this.$menuElements = this.$menuContainer.find(this.level.elementSel);
            this.initBarEl();
        },

        init: function() {
            this.initLinks();
            this.$menuElements
                .on('mouseover.slideLineMenu', this.enterHandler.bind(this))
                .on('mouseout.slideLineMenu', this.leaveHandler.bind(this));
        },

        initLinks: function() {
            this.$menuContainer
                .find(this.level.linkSel)
                .originalAddClass(ANIMATION_CLASS);
        },

        initBarEl: function() {
            let bar = document.createElement('li');
            bar.classList.add(EFFECT_CLASS);

            const menuEl = this.$menuElements[0];

            if (!menuEl) {
                return;
            }

            const linkEl = menuEl.querySelector(this.level.linkSel);
            let barTop, barHeight;

            if (this.level === FIRST_LEVEL) {
                let linkElCs = window.getComputedStyle(linkEl);
                barHeight = parseFloat(linkElCs.fontSize) * 0.4;
                barTop = this.$menuContainer[0].offsetHeight - barHeight;
            } else {
                barHeight = linkEl.offsetHeight;
                barTop = linkEl.offsetTop + linkEl.parentElement.offsetTop;
            }

            bar.style.height = barHeight + 'px';
            bar.style.height = barHeight + 'px';
            bar.style.top = barTop + 'px';
            bar.style.listStyle = 'none';
            this.$menuContainer.originalAppend(bar);
        },

        moveBarToCurrentMenuItem: function(width, left) {
            this.$menuContainer
                .find(getSel(EFFECT_CLASS))
                .originalRemoveClass('vanished')
                .css('width', width + 'px')
                .css('left', left + 'px');
        },

        enterHandler: function(e) {
            let target = e.currentTarget.querySelector(getSel(ANIMATION_CLASS));

            // Skip inner containers as parents
            if (target.parentElement.className === 'inner') {
                target = target.parentElement;
            }

            const width = target.offsetWidth;
            const left = target.offsetLeft + target.parentElement.offsetLeft;

            this.moveBarToCurrentMenuItem(width, left);
        },

        leaveHandler: function() {
            this.$menuContainer.find(getSel(EFFECT_CLASS)).originalAddClass('vanished');
        },

        clearAnimation: function() {
            this.$menuElements && this.$menuElements.off('.slideLineMenu');
            this.$menuContainer && this.$menuContainer.find(getSel(EFFECT_CLASS)).remove();
        }

    });

    module.exports = {

        init: function(widget) {
            const $el = widget.$el;

            if ($el.hasClass('slide-line-menu')) {
                return;
            }

            $el.originalAddClass('slide-line-menu');

            const sliders = [new SlideLineAnimation(FIRST_LEVEL, $el), new SlideLineAnimation(SECOND_LEVEL, $el)];

            sliders.forEach(function(slider) {
                slider.init();
            });
            // refresh bar when second level menu is changed
            core.on('page:rendered page:shown', function() {
                sliders.forEach(function(slider) {
                    slider.init();
                });
            });
        }

    };
});
